import React, { useState } from "react";
import ChangeLanguage from "./ChangeLanguage";
import { Translation } from "react-i18next";

const logoStyle = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

class NavContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderMobile: false,
    };
    this.menu = React.createRef();
    this.display_menu = this.display_menu.bind(this);
  }
  display_menu(e) {
    console.log(e);
    this.setState({
      renderMobile: !this.state.renderMobile,
    });
  }
  getRenderMobile() {
    console.log(this.state.renderMobile);
    return this.state.renderMobile;
  }
  render() {
    return (
      <nav className="nav-container" id="nav-container">
        <div className="max-width-container  MuiGrid-spacing-main-1">
          <div
            className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-5"
            style={{ alignItems: "center" }}
          >
            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-10 MuiGrid-grid-sm-4">
              <div className="logo-container">
                <a data-testid="navbar-logo" href="/">
                  <div style={logoStyle}>
                    <img
                      src="https://api-cdn.zhink.cn/logo1.png"
                      style={{ width: "216px" }}
                      alt="GPT-3 Demo"
                      title="GPT-3 Demo"
                    />
                    <Translation>
                      {(t) => (
                        <span className="post-fix">
                          | {t("home.logo-subtitle")}
                        </span>
                      )}
                    </Translation>
                  </div>
                </a>
              </div>
            </div>
            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-2 MuiGrid-grid-sm-8">
              <div className="menu-container">
                <ul className="menu">
                  <li className="button">
                    <a href="https://gptx.ai/" data-testid="header-item" target="blank">
                      Open AI
                    </a>
                  </li>
                  <li className="link">
                    <a href="https://www.alibaba.com" data-testid="header-item" target="blank">
                      Alibaba
                    </a>
                  </li>
                  <li className="link">
                    <a href="https://www.puxiang.com" data-testid="header-item" target="blank">
                      Industrial Design
                    </a>
                  </li>
                  <li className="link">
                    <ChangeLanguage />
                  </li>
                </ul>
                {this.state.renderMobile && (
                  <div style={{ "margin-right": "10px" }}>
                    <ChangeLanguage />
                    <span> </span>
                  </div>
                )}
                <div
                  className="mobile-menu-container"
                  onClick={this.display_menu}
                >
                  <div className="mobile-menu ICON">
                    <svg width="32" height="32" viewBox="0 0 24 24">
                      <path
                        fill="#FFF"
                        d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="mobile-login-container">
                  <div className="">
                    <div>
                      <button>Sign in</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default NavContainer;
